'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';

// 다른 탭/창에 있다가 이 탭으로 돌아왔을 때 서버 컴포넌트를 다시 렌더링해
// 최신 데이터(가격 등)를 반영한다. (어드민에서 값을 바꿔도 이미 열려있는
// 탭은 새로고침 전까진 반영이 안 되던 문제)
const FocusRefresh = () => {
  const router = useRouter();

  useEffect(() => {
    const handleFocus = () => {
      router.refresh();
    };
    window.addEventListener('focus', handleFocus);
    return () => window.removeEventListener('focus', handleFocus);
  }, [router]);

  return null;
};

export default FocusRefresh;
